import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function StudentIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M3 6v7.5m2.08 6.75a8.258 8.258 0 0 1 13.839 0M21 6l-9 3-9-3 9-3 9 3Z" stroke="currentColor"
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M15.871 7.705a5.25 5.25 0 1 1-7.743 0" stroke="currentColor" strokeLinecap="round"
            strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
